import React, { useState, useEffect } from "react";
import RequestService from "../services/RequestService";
import UserService from "../services/UserService";
import { FaCircle } from "react-icons/fa";
import { parseISO, format, differenceInHours } from "date-fns";
import DeliverModal from './modals/DeliverModal';
import RequestDetailsModal from "./modals/RequestDetailsModal";
import { FaLongArrowAltDown } from "react-icons/fa";
import { isSLAPassed, isSLANear, isSLATwoHour } from "../utils/SLACalcs";
import StatusRequests from './../enums/StatusRequests';
import { RiTimerLine } from "react-icons/ri";
import { AiFillAlert } from "react-icons/ai";
import { useOutletContext } from 'react-router-dom';
import SendToManagementModal from './modals/SendToManagementModal';
import BoardingModal from "./modals/BoardingModal";
import { startPolling } from "../utils/polling";


export default function RouteDelivery() {

  const statusColor = {
    "REPASSE PARA COLETA": "#bae6fd",
    "ROTA DE COLETA": "#38bdf8",
  }

  const { user } = useOutletContext();

  const [deliverModal, setDeliverModal] = useState(false);
  const [requestOnDeliverModal, setRequestOnDeliverModal] = useState();
  const [requestNroOnDeliverModal, setRequestNroOnDeliverModal] = useState();

  const [requestDetailsModal, setRequestDetailsModal] = useState(false);
  const [requestOnDetailsModal, setRequestOnDetailsModal] = useState();

  const [sendToManagementModal, setSendToManagementModal] = useState(false);
  const [requestOnMngtModal, setRequestOnMngtModal] = useState();

  const [boardingModal, setBoardingModal] = useState(false)
  const [requestOnBoardingModal, setRequestOnBoardingModal] = useState();

  const [requestListRota, setRequestListRota] = useState({ requests: [], totalPages: 1 });
  const [currentPageRota, setCurrentPageRota] = useState(1);

  const [reload, setReload] = useState(false);

  //filters
  const [search, setSearch] = useState('');
  const [tempSearch, setTempSearch] = useState(''); // Estado temporário para o input
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  // const [status, setStatus] = useState('');

  const [editingEntregadorId, setEditingEntregadorId] = useState(null);
  const [entregadorSearch, setEntregadorSearch] = useState("");
  const [entregadoresList, setEntregadoresList] = useState([]);
  const [loadingChange, setLoadingChange] = useState(false);


  useEffect(() => {

    // Função para buscar os requests
    const fetchRequests = async () => {
      const status = 'ROTA DE ENTREGA'
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      if (status) params.append('status', status);

      const queryString = params.toString();
      const requestsRota = await RequestService.getRequest(`?${queryString}`, currentPageRota);
      setRequestListRota(requestsRota);
    };

    // Chamada inicial
    const fetchData = () => {
      fetchRequests();
    };

    fetchData()

    return startPolling(fetchData);

  }, [currentPageRota, endDate, search, startDate, deliverModal, reload]);

  // Buscar entregadores ao digitar
  useEffect(() => {
    if (entregadorSearch.trim() === "") {
      setEntregadoresList([]);
      return;
    }
    const fetch = setTimeout(async () => {
      try {
        const results = await UserService.getEntregadores(entregadorSearch);
        setEntregadoresList(results);
      } catch (e) {
        setEntregadoresList([]);
      }
    }, 300);
    return () => clearTimeout(fetch);
  }, [entregadorSearch]);

  const handlePageChangeRota = (newPage) => {
    if (newPage >= 1 && newPage <= requestListRota.totalPages) {
      setCurrentPageRota(newPage);
    }
  };

  const handleEntregar = async (ticketId,requestNro) => {
    setDeliverModal(true)
    setRequestOnDeliverModal(ticketId)
    setRequestNroOnDeliverModal(requestNro)
  };

  const handleRequestDetailsModal = async (ticketId) => {
    setRequestDetailsModal(true)
    setRequestOnDetailsModal(ticketId)
  };

  const handleGestao = async (ticketId, requestNro) => {
    setSendToManagementModal(true)
    setRequestOnMngtModal(ticketId)
    // setRequestNroOnMngtModal(requestNro)
  };

  const handleBoardingModal = (ticketId) => {
    setBoardingModal(true)
    setRequestOnBoardingModal(ticketId)
  }

  const renderFurtoVandalismoFlag = (request) => {
    if (!request?.isFurtoVandalismo) {
      return '-';
    }

    return (
      <div className="flex items-center justify-center gap-1 text-red-600 font-bold whitespace-nowrap">
        <span className="inline-block h-2.5 w-2.5 rounded-full bg-red-500"></span>
      </div>
    );
  };

  // ====== FILTER FUNCTIONS ====== 

  const clearFilters = () => {
    setSearch('');
    setTempSearch('');
    setStartDate('');
    setEndDate('');
    // setStatus('');
  };

  const handleSearchChange = (e) => {
    // setSearch(e.target.value);
    setTempSearch(e.target.value); // Atualiza o estado temporário
  };

  const handleSearchBlur = () => {
    setSearch(tempSearch); // Atualiza o estado principal quando o input perde o foco
    console.log(tempSearch);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    console.log(e.target.value)
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    console.log(e.target.value)
  };
  
  // ====== END FILTER FUNCTIONS ====== 


  return (
    <div className="flex w-full h-full justify-center items-center py-4 px-4 bg-gray-200">

      <div className="flex flex-col w-full h-full rounded-xl py-8 px-6 gap-12 bg-white">

        <div className="flex flex-col w-full h-full gap-2 border border-gray-800 border-opacity-40 rounded-xl p-2">
          <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-2">
            <FaCircle
              color={StatusRequests["ROTA DE ENTREGA"]?.cor}
              size={15}
            />
            ROTA DE ENTREGA
          </div>

          <div className="flex flex-col justify-between w-full h-full">
            <div className="flex flex-col gap-4">

              <div className="flex items-end w-full rounded-md gap-4 mt-2 text-[10px]">
                <div className="flex space-x-4 text-[12px]">
                  <div className="flex flex-col">
                    <label className="font-semibold ms-2">Pesquisar</label>
                    <input
                      type="text"
                      placeholder="Search"
                      value={tempSearch}  // Vincula o valor ao estado temporário
                      onChange={handleSearchChange}  // Atualiza o estado temporário em tempo real
                      onBlur={handleSearchBlur}  // Atualiza o estado principal ao perder o foco
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="font-semibold ms-2">Data Início</label>
                    <input
                      type="date"
                      placeholder="Start Date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="font-semibold ms-2">Data Fim</label>
                    <input
                      type="date"
                      placeholder="End Date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  {/* <div className="flex flex-col">
                  <label className="font-semibold">Status</label>
                  <select
                    value={status}
                    onChange={handleStatusChange}
                    className="border border-gray-300 rounded px-2 py-2"
                  >
                    <option value="">Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div> */}
                </div>

                <div className="flex gap-2">
                  {/* <button onClick={handleSubmit} className="bg-zinc-800 hover:bg-zinc-700 text-white h-6 px-4 rounded-2xl w-40">
                  Buscar
                </button> */}
                  <button onClick={clearFilters} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                    Limpar Filtros
                  </button>
                </div>
              </div>

              <div className="overflow-x-auto">
                <table className="min-w-full bg-white rounded-lg text-[10px]">
                  <thead className="bg-[#38bdf8]">
                    <tr>
                      {/* <th className="py-2 px-4 border-b rounded-tl-lg">Tipo</th> */}
                      <th className="py-2 px-4 border-b rounded-tl-lg">Status</th>
                      <th className="py-2 px-4 border-b">ID</th>
                      <th className="py-2 px-4 border-b">Criado em</th>
                      <th className="py-2 px-4 border-b">Cod Sap</th>
                      <th className="py-2 px-4 border-b">Furto/Vand.</th>
                      <th className="py-2 px-4 border-b">DRS Atender</th>
                      <th className="py-2 px-4 border-b">Cidade</th>
                      <th className="py-2 px-4 border-b">Qtd</th>
                      <th className="py-2 px-4 border-b">Atendimento</th>
                      <th className="py-2 px-4 border-b">Técnico</th>
                      <th className="py-2 px-4 border-b">Entregador</th>
                      <th className="py-2 px-4 border-b">Multi-trecho</th>
                      <th className="py-2 px-4 border-b">Obs Entrega</th>
                      <th className="py-2 px-4 border-b"><div className="flex justify-center items-center">Data SLA<FaLongArrowAltDown /></div></th>
                      <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {/* {requestListRota?.requests?.length > 0 &&
                    <tr>
                      <td colSpan="13" className="bg-neutral-400 text-white ps-6 font-extralight py-1 rounded-full"><div className="flex gap-2 items-center"><IoMdArrowDropdown size={17}/>Solicitações</div></td>
                    </tr>
                    } */}
                    {requestListRota.requests?.map((request, index) => (
                      <tr
                        key={`request-${index}`}
                        className={`border-t hover:bg-gray-100 ${isSLAPassed(request.slaDate)
                          ? "bg-red-100"
                          : isSLANear(request.slaDate)
                            ? "bg-yellow-100"
                            : isSLATwoHour(request.slaDate)
                              ? "bg-yellow-200"
                              : ""
                          }`}
                      >
                        {/* <td className="py-1 px-4"><div className="flex justify-start items-center gap-2 text-[10px] font-semibold">SOLICITAÇÃO</div></td> */}
                        <td className="py-1 px-4">
                          <div className="flex justify-start items-center gap-2">
                            <FaCircle
                              color={"#38bdf8"}
                              size={15}
                            />
                            {request.status}
                          </div>
                        </td>
                        <td className="py-1 px-4 cursor-pointer underline font-bold" onClick={() => handleRequestDetailsModal(request._id)}>{request.idRequest}</td>
                        <td className="py-1 px-4">{format(parseISO(request.createdAt), 'dd/MM/yy HH:mm')}</td>
                        <td className="py-1 px-4 whitespace-nowrap">{request.codSap}</td>
                        <td className="py-1 px-4 text-center">{renderFurtoVandalismoFlag(request)}</td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.drsAtender?.sigla}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{request.cidadeEntrega === 'SÃO PAULO' ? 'SP-' + request.gmo.identificador : request.cidadeEntrega}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeAtender}</div></td>
                        <td className="py-1 px-4">
                          <div className="flex justify-center items-center gap-2">
                            {["bbn-alta", "bbn-media"].includes(request.tipoAtendimento) ? (
                              <span className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                                {request.tipoAtendimento.toUpperCase()}
                              </span>
                            ) : (
                              request.tipoAtendimento.toUpperCase()
                            )}
                          </div>
                        </td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.tecnico} - {request.telefone}</div></td>
                        {/* <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.nomeEntregador} - {request.telefoneEntregador}</div></td> */}
                        <td className="py-1 px-4 relative">
                          {request.isMultiTrecho && editingEntregadorId === request._id ? (
                            <div className="relative flex flex-col gap-1">
                              <div className="flex gap-2">
                                <input
                                  type="text"
                                  value={entregadorSearch}
                                  onChange={e => setEntregadorSearch(e.target.value)}
                                  placeholder="Buscar entregador"
                                  className="block w-full min-w-40 rounded-2xl px-2 py-1 text-gray-900 shadow-sm border border-zinc-500 outline-none ring-0 text-xs"
                                  ref={inputRef => {
                                    // Salva a referência para calcular a posição do dropdown
                                    if (inputRef && editingEntregadorId === request._id) {
                                      window._entregadorInputRef = inputRef;
                                    }
                                  }}
                                />
                                <button
                                  className=" bg-gray-300 rounded-full px-2 text-black whitespace-nowrap"
                                  onClick={() => {
                                    setEditingEntregadorId(null);
                                    setEntregadorSearch("");
                                    setEntregadoresList([]);
                                  }}
                                  type="button"
                                >
                                  Cancelar
                                </button>
                              </div>
                              {entregadoresList.length > 0 && (() => {
                                // Calcula a posição do dropdown em relação à tela
                                let top = 0, left = 0, width = 0;
                                if (window._entregadorInputRef) {
                                  const rect = window._entregadorInputRef.getBoundingClientRect();
                                  top = rect.bottom + window.scrollY;
                                  left = rect.left + window.scrollX;
                                  width = rect.width;
                                }
                                return (
                                  <div
                                    className="fixed max-h-40 overflow-y-auto bg-white rounded shadow-lg border border-gray-200 z-50"
                                    style={{
                                      top,
                                      left,
                                      width,
                                      minWidth: 200
                                    }}
                                  >
                                    <ul>
                                      {entregadoresList.map((entregador) => (
                                        <li
                                          key={entregador._id}
                                          className="px-2 py-1 cursor-pointer hover:bg-gray-100 text-xs"
                                          onClick={async () => {
                                            setLoadingChange(true);
                                            try {
                                              await RequestService.changeEntregador(request._id, {
                                                entregadorId: entregador._id,
                                                nomeEntregador: entregador.name,
                                                telefoneEntregador: entregador.phone,
                                                matriculaEntregador: entregador.reLegal,
                                              });
                                              setEditingEntregadorId(null);
                                              setEntregadorSearch("");
                                              setEntregadoresList([]);
                                              setReload(!reload);
                                            } catch (e) {
                                              alert(e.message || "Erro ao trocar entregador");
                                            }
                                            setLoadingChange(false);
                                          }}
                                        >
                                          {entregador.name} - {entregador.company?.name}
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                );
                              })()}
                            </div>
                          ) : (
                            <div className="flex items-center gap-2">
                              <span>{request.nomeEntregador} - {request.telefoneEntregador}</span>
                              {request.isMultiTrecho && (
                                <button
                                  className=" bg-blue-500 rounded-full px-2 text-white whitespace-nowrap"
                                  onClick={() => {
                                    setEditingEntregadorId(request._id);
                                    setEntregadorSearch("");
                                    setEntregadoresList([]);
                                  }}
                                  disabled={loadingChange}
                                >
                                  Trocar Entregador
                                </button>
                              )}
                            </div>
                          )}
                        </td>
                        <td className="py-1 px-4">
                          <input
                            type="checkbox"
                            checked={!!request.isMultiTrecho}
                            onChange={async (e) => {
                              const checked = e.target.checked;
                              const confirmMsg = checked
                                ? "Deseja realmente ATIVAR o Multi-trecho para esta solicitação?"
                                : "Deseja realmente DESATIVAR o Multi-trecho para esta solicitação?";
                              if (!window.confirm(confirmMsg)) {
                                return;
                              }
                              try {
                                await RequestService.updateParcial(request._id, { isMultiTrecho: checked });
                                setReload((prev) => !prev); // Atualiza a lista após alteração
                              } catch (err) {
                                alert("Erro ao atualizar Multi-trecho");
                              }
                            }}
                            style={{ width: 16, height: 16 }}
                          />
</td>
                        <td className="py-1 px-4">{request.ultimaObs}</td>
                        <td
                          className={`py-1 px-4 ${request?.slaDate && isSLAPassed(request.slaDate)
                            ? "text-red-500 font-bold"
                            : request?.slaDate && isSLANear(request.slaDate)
                              ? "text-yellow-600 font-bold"
                              : request?.slaDate && isSLATwoHour(request.slaDate)
                                ? "text-yellow-600 font-bold animate-pulse-fast"
                                : ""
                            }`}
                        >
                          <div className="flex gap-1 items-center font-bold">
                            {request?.slaDate
                              ? format(parseISO(request.slaDate), "dd/MM/yy HH:mm")
                              : "N/A"}
                            {request?.slaDate && isSLATwoHour(request.slaDate) && (
                              <RiTimerLine size={12} />
                            )}
                          </div>
                        </td>
                        <td className="py-1 px-4">
                          <div className="flex justify-center gap-2 h-5 text-[11px]">
                            <button
                              className=" bg-gray-700 rounded-full px-2 text-white whitespace-nowrap"
                              // onClick={()=>generatePDF(request)}
                              onClick={() => handleBoardingModal(request._id)}
                            >
                              Nota Embarque
                            </button>
                            <button
                              className="flex items-center gap-1 bg-sky-700 rounded-full px-2 text-white whitespace-nowrap"
                              onClick={() => handleEntregar(request._id, request.idRequest)}
                            >
                              Informar Entrega
                            </button>
                            {(user.email === 'junior.silva@amerinode.com.br' || 
                              user.email === 'guilherme.alberto@amerinode.com.br' || 
                              user.email === 'jean.medeiros@amerinode.com.br' ||
                              user.email === 'renato.silva@amerinode.com.br') &&
                              <button
                                className="flex items-center gap-1 bg-rose-800 rounded-full px-2 text-white"
                                onClick={() => handleGestao(request._id, request.idRequest)}
                              >
                                Gestão
                                <AiFillAlert />
                              </button>
                            }
                          </div>
                        </td>
                      </tr>
                    ))}
                    {/* {collectOrdersRota?.collectOrders?.length > 0 &&
                    <tr>
                      <td colSpan="13" className="bg-neutral-400 text-white ps-6 font-extralight py-1 rounded-full"><div className="flex gap-2 items-center"><IoMdArrowDropdown size={17}/>Coletas</div></td>
                    </tr>
                    }
                    {collectOrdersRota.collectOrders?.map((collectOrder, index) => (
                      <tr key={index} className={`border-b hover:bg-gray-100 ${isSLAPassed(collectOrder.slaCollectDate) ? 'bg-red-50' : isSLANear(collectOrder.slaCollectDate) ? 'bg-yellow-50' : ''}`}>
                        <td className="py-1 px-4">
                          <div className="flex justify-start items-center gap-2">
                            <FaCircle
                            color={"#38bdf8"}
                            size={15}
                          />
                          {collectOrder.status}
                          </div>
                        </td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">-</div></td>
                        <td className="py-1 px-4">{format(parseISO(collectOrder.createdAt), 'dd/MM/yy HH:mm')}</td>
                        <td className="py-1 px-4 whitespace-nowrap">{collectOrder.codEquipamentoEsperado}</td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">-</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.gmo.cidade}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.qtdEquipamentoEsperado}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">-</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.nomeSolicitante}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">-</div></td>                      
                        <td className="py-1 px-4">{collectOrder.observacaoColeta}</td>
                        <td className={`py-1 px-4 ${isSLAPassed(collectOrder.slaCollectDate) ? 'text-red-500 font-bold' : isSLANear(collectOrder.slaCollectDate) ? 'text-yellow-600 font-bold' : ''} `}>
                          {collectOrder?.slaCollectDate ? format(parseISO(collectOrder.slaCollectDate), 'dd/MM/yy HH:mm') : "" }
                        </td>
                        <td className="py-1 px-4">-</td>
                      </tr>
                    ))} */}
                  </tbody>
                </table>
              </div>

            </div>

            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 gap-2 text-xs">
              <button
                className={`px-2 py-1 rounded-md ${currentPageRota === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChangeRota(currentPageRota - 1)}
                disabled={currentPageRota === 1}
              >
                {'<'}
              </button>
              {[...Array(requestListRota.totalPages)].map((_, index) => (
                <button
                  key={index}
                  className={`px-2 py-1 rounded-md ${currentPageRota === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                  onClick={() => handlePageChangeRota(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
              <button
                className={`px-2 py-1 rounded-md ${currentPageRota === requestListRota.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChangeRota(currentPageRota + 1)}
                disabled={currentPageRota === requestListRota.totalPages}
              >
                {'>'}
              </button>
            </div>

          </div>
        </div>

      </div>

      { requestOnDeliverModal && 
      <div className="absolute">
        <DeliverModal
          isModalOpen={deliverModal}
          setModalOpen={() => {
            setDeliverModal(!deliverModal);
          }}
          requestId={requestOnDeliverModal}
          requestNro={requestNroOnDeliverModal}
          // setTicketCb={setTicket}
        ></DeliverModal>
      </div>
      }

      {requestOnDetailsModal && 
        <div className="absolute">
          <RequestDetailsModal
            isModalOpen={requestDetailsModal}
            setModalOpen={() => {
              setRequestDetailsModal(!requestDetailsModal);
            }}
            requestId={requestOnDetailsModal}
            // setTicketCb={setTicket}
          ></RequestDetailsModal>
        </div>
      }

      {requestOnMngtModal &&
        <div className="absolute">
          <SendToManagementModal
            isModalOpen={sendToManagementModal}
            setModalOpen={() => {
              setSendToManagementModal(!sendToManagementModal);
            }}
            requestId={requestOnMngtModal}
          // requestNro={requestNroOnMngtModal}
          // setTicketCb={setTicket}
          ></SendToManagementModal>
        </div>
      }

      {requestOnBoardingModal &&
        <div className="absolute">
          <BoardingModal
            isModalOpen={boardingModal}
            setModalOpen={() => {
              setBoardingModal(!boardingModal);
            }}
            requestId={requestOnBoardingModal}
          // setTicketCb={setTicket}
          ></BoardingModal>
        </div>
      }

    </div>
  )
}
